// extracted by mini-css-extract-plugin
module.exports = {"container":"BasicLayout_container__3p2ju","layout":"BasicLayout_layout__DIggN","contents":"BasicLayout_contents__onpii"};